/**
 * Check to see if the given email is valid according to
 * some basic regex.
 *
 * @see https://stackoverflow.com/a/1373724
 *
 * @export
 * @param {String} email The email to test.
 * @returns {Boolean} Whether or not the given email is valid.
 */
export default function(email) {
  let regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return regex.test(email);
}



// WEBPACK FOOTER //
// ./src/utils/is-valid-email.js